import { Play } from "lucide-react";
import { useState } from "react";

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);
  const videoId = "x5XGmfInhrk";

  return (
    <section data-testid="video-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b22300] mb-3 text-center">See It in Action</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          Watch How Our Stair Lifts Work
        </h2>
        <p className="mt-3 text-stone-500 text-center max-w-xl mx-auto">
          See how a Vin Grace stair lift transforms home mobility - smooth, safe, and installed in just 1-2 days
        </p>

        <div className="mt-8 relative rounded-2xl overflow-hidden shadow-lg border border-stone-200 aspect-[9/16] sm:aspect-video max-w-sm sm:max-w-full mx-auto bg-stone-900">
          {!playing ? (
            <div className="absolute inset-0 cursor-pointer group" onClick={() => setPlaying(true)}>
              <img
                src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                alt="Stairlift demonstration video"
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                }}
              />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                <div data-testid="video-play-btn" className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#b22300] group-hover:bg-[#d43a1a] transition-colors flex items-center justify-center shadow-xl">
                  <Play className="w-7 h-7 sm:w-9 sm:h-9 text-white ml-1" fill="white" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg px-3 py-1.5">
                <p className="text-white text-xs font-medium">Stair Lift Demo</p>
              </div>
            </div>
          ) : (
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
              title="Vin Grace Stair Lift Video"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
            />
          )}
        </div>

        <div className="mt-6 grid grid-cols-3 gap-4 text-center">
          <div className="rounded-xl bg-stone-50 border border-stone-100 p-4">
            <p className="text-stone-900 font-bold text-lg font-['Outfit']">1-2 Days</p>
            <p className="text-stone-500 text-xs mt-1">Quick Installation</p>
          </div>
          <div className="rounded-xl bg-stone-50 border border-stone-100 p-4">
            <p className="text-stone-900 font-bold text-lg font-['Outfit']">Zero Noise</p>
            <p className="text-stone-500 text-xs mt-1">Whisper-Quiet Motor</p>
          </div>
          <div className="rounded-xl bg-stone-50 border border-stone-100 p-4">
            <p className="text-stone-900 font-bold text-lg font-['Outfit']">24/7 Ready</p>
            <p className="text-stone-500 text-xs mt-1">Battery Backup</p>
          </div>
        </div>
      </div>
    </section>
  );
}
